import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-find-contract',
  templateUrl: './find-contract.component.html',
  styleUrls: ['./find-contract.component.scss']
})
export class FindContractComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
